import { useQuery } from "@tanstack/react-query";

import { getAdvisoryTools } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import keys from "../keys";

export const useAdvisoryToolsQuery = (categories: string[] | undefined) => {
	return useQuery({
		queryKey: keys.advisoryTools(categories),
		queryFn: processResponse(() => getAdvisoryTools(categories)),
		enabled: !!categories && categories.length > 0,
	});
};
